import { AppMedia, breakpoints } from "./media";

export const mediaStyles = AppMedia.createMediaStyle();
export const { Media, MediaContextProvider } = AppMedia;
export const Breakpoints = breakpoints;
